<div class="filter-widget" (focusout)="onBlur()" tabindex="1">
    <input #filterInput type="text" [(ngModel)]="filterQuery" (input)="onFilter()" maxLength="{{maxChars}}"
        [class.filter-active]="!isFilteringInProgress && filterQuery.trim()" (keydown.enter)="onFilter($event)"
        [class.filtering-in-progress]="isFilteringInProgress" [disabled]="isDisabled" placeholder="{{placeholder}}"
        [attr.data-automation-id]="filterInputAutoId + '-filter-input'" [inputFocus]="autofocusInput">
    <button [class.filter-visible]="filterQuery.trim()"
        [class.filter-active-background]="!isFilteringInProgress && filterQuery.trim()"
        [class.filter-clear]="!filterQuery.trim()" (click)="clear()"
        [attr.data-automation-id]="clearButtonDataAutoId + '-filter-input-close-button'">
        <i class="fa" [class.fa-filter]="!isFilteringInProgress && !filterQuery.trim()"
            [class.fa-times]="!isFilteringInProgress && filterQuery.trim()"
            [ngClass]="[isFilteringInProgress ? 'fa-spinner fa-spin' : '']"></i>
    </button>
</div>